import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
    title: {
        ...theme.typographyPresets.titleMedium,
        marginBottom: 20,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.colors.light.lightGray,
        paddingTop: '56px',
    },
    content: {
        flex: 1,
        padding: '20px',
        display: 'flex',
        minHeight: '80vh',
    },
    article: {
        ...theme.typographyPresets.bodySecondary,
        margin: '10% auto auto',
        maxWidth: '680px',
    },
}))
